import * as React from 'react'
import { Button, Card, CardContent, CardHeader, PasswordWithConfirm, useToast } from '@/shared/ui'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/lib/supabase'
import { updatePassword } from '../services/passwordRecoveryService'

export default function ResetPasswordPage() {
  const navigate = useNavigate()
  const { add: toast } = useToast()
  const [checking, setChecking] = React.useState(true)
  const [sessionOk, setSessionOk] = React.useState(false)
  const [pwd, setPwd] = React.useState('')
  const [confirm, setConfirm] = React.useState('')
  const [submitting, setSubmitting] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    let active = true
    ;(async () => {
      try {
        // Supabase com detectSessionInUrl vai aplicar o token desta URL automaticamente
        // Conferimos se a sessão está presente; caso não, o link é inválido/expirado
        const { data } = await supabase.auth.getSession()
        if (!active) return
        setSessionOk(!!data.session?.user)
      } finally {
        if (active) setChecking(false)
      }
    })()
    return () => { active = false }
  }, [])

  const canSubmit = pwd.length >= 6 && pwd === confirm && !submitting && sessionOk

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!canSubmit) return
    setError(null)
    setSubmitting(true)
    try {
      const { error } = await updatePassword(pwd)
      if (error) throw error
      toast({ title: 'Senha atualizada', description: 'Faça login com sua nova senha.', variant: 'success' })
      navigate('/login', { replace: true })
    } catch (err: any) {
      setError(err?.message || 'Falha ao atualizar senha. O link pode ter expirado.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="flex min-h-[100dvh] items-center justify-center px-4 py-8">
      <Card className="w-full max-w-md">
        <CardHeader className="text-lg font-semibold">Redefinir senha</CardHeader>
        <CardContent>
          {checking ? (
            <div className="text-sm text-foreground/70">Validando link...</div>
          ) : sessionOk ? (
            <form className="space-y-4" onSubmit={onSubmit}>
              {error && (
                <div className="rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>
              )}
              <PasswordWithConfirm
                password={pwd}
                confirm={confirm}
                onChange={(p)=>{ if (typeof p.password === 'string') setPwd(p.password); if (typeof p.confirm === 'string') setConfirm(p.confirm) }}
                required
              />
              <div className="flex justify-end gap-2">
                <Button type="button" variant="secondary" onClick={() => navigate('/login')}>Cancelar</Button>
                <Button type="submit" disabled={!canSubmit}>{submitting ? 'Salvando...' : 'Salvar nova senha'}</Button>
              </div>
            </form>
          ) : (
            <div className="space-y-4">
              <div className="rounded-md border border-amber-500/30 bg-amber-500/10 p-3 text-sm text-amber-700 dark:text-amber-400">
                Link inválido ou expirado. Solicite um novo link de redefinição.
              </div>
              <div className="flex justify-end">
                <Button onClick={() => navigate('/login')}>Voltar ao login</Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

